import { List } from 'immutable'
import { featureImages } from 'data/global/feature-images'
import { useLanguage } from 'store/locale/hooks/useLanguage'

export interface IHash<T> {
  [key: string]: T
}

export interface IImage {
  alt: string
  url: string
  urlResponsive?: {
    mobile: string
    desktop: string
  }
  link?: string
  text?: string[]
}

export type IImageHash = IHash<IImage>
export type IFeaturedImageHash = IHash<IImageHash>

export const useImages = (namespace: string) => {
  const { language } = useLanguage()
  const images = featureImages.get(language)?.[namespace]
  const defaultImage: IImage = { alt: 'default image', url: '' }
  const getImage = (key: string) => (images && images[key]) || defaultImage

  const getImages = () => {
    const imageList: IImage[] = []

    if (images) {
      for (const prop in images) {
        imageList.push(images[prop])
      }
    }

    return List(imageList)
  }

  return { getImage, getImages }
}
